"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFirstRender = void 0;
const react_1 = require("react");
function useFirstRender(callback) {
    const firstRender = react_1.useRef(true);
    if (firstRender.current) {
        firstRender.current = false;
        callback();
    }
}
exports.useFirstRender = useFirstRender;
//# sourceMappingURL=first-render.js.map